import React from 'react';
import AccountTab from './AccountTab';
import InstallationTab from './InstallationTab';
import CapVendaTab from './CapVendaTab';
import UltMovsTab from './UltMovsTab';
import { Link, Route } from 'react-router-dom'
import ContaTabs from '../ContaTabs'

class ContaTabsContainer extends React.Component {

  render() {
    return (
      <div className="mt-4">
        <ContaTabs search={ this.props.location.search } date={new Date()} />
        <ul className="nav nav-tabs tab-container">
          <li className="nav-item">
            <Link className={ `nav-link p-3 border ${this.props.location.pathname.includes('account') ? 'active' : 'bg-white text-body'}` } to={ { pathname: 'account', search: this.props.location.search } }><span className="k-icon k-i-menu"></span>&nbsp;Por Conta Corrente Vínica</Link>
          </li>
          <li className="nav-item">
            <Link className={ `nav-link p-3 border ${this.props.location.pathname.includes('installation') ? 'active' : 'bg-white text-body'}` } to={ { pathname: 'installation', search: this.props.location.search } }><span className="k-icon k-i-menu"></span>&nbsp;Por Instalação Vínica</Link>
          </li>
          <li className="nav-item">
            <Link className={ `nav-link p-3 border ${this.props.location.pathname.includes('capvenda') ? 'active' : 'bg-white text-body'}` } to={ { pathname: 'capvenda', search: this.props.location.search } }><span className="k-icon k-i-menu"></span>&nbsp;Por Capacidade Venda</Link>
          </li>   
          <li className="nav-item">
            <Link className={ `nav-link p-3 border ${this.props.location.pathname.includes('ultmovs') ? 'active' : 'bg-white text-body'}` } to={ { pathname: 'ultmovs', search: this.props.location.search } }><span className="k-icon k-i-menu"></span>&nbsp;Últimos Movimentos</Link>
          </li>                 
        </ul>
        <div className="table-section custom-k-grid pt-3">
          <div className="table-responsive">
            <Route path={ `${this.props.match.path}/account` } component={ AccountTab } />
            <Route path={ `${this.props.match.path}/installation` } component={ InstallationTab } />
            <Route path={ `${this.props.match.path}/capvenda` } component={ CapVendaTab } />
            <Route path={ `${this.props.match.path}/ultmovs` } component={ UltMovsTab } />
          </div>
        </div>
      </div>
    )
  }
}

export default ContaTabsContainer;
